import React, { useContext, useRef, useEffect } from 'react';
import {
  useDataModel, params, shape, arrayOf, string
} from '@thd-nucleus/data-sources';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ResultsHeader } from '../components/ResultsHeader';

export const PLPResultsHeader = ({ preamble }) => {

  const expContext = useContext(ExperienceContext);
  const { customContext } = expContext;
  const variables = { ...customContext?.variables || {} };
  const resultsRef = useRef(null);
  const defaultOptions = {
    variables,
    ssr: true,
    skip: !variables.navParam && !variables.keyword
  };
  const { data, loading, error } = useDataModel('searchModel', defaultOptions);

  const isDynamicBrandPage = data?.searchModel?.aisles?.length > 0;

  useEffect(() => {
    const handleResultsRefUpdate = (event) => {
      if (event.ref) {
        resultsRef.current = event.ref;
      }
    };

    window.LIFE_CYCLE_EVENT_BUS.on('default-grid.results-ref-update', handleResultsRefUpdate);

    return () => {
      window.LIFE_CYCLE_EVENT_BUS.off('default-grid.results-ref-update', handleResultsRefUpdate);
    };
  }, []);

  if (!data || (!data && loading) || (!data && error)) {
    return null;
  }

  return (
    <ResultsHeader
      preamble={preamble}
      showShopAllLink={isDynamicBrandPage}
      resultsRef={resultsRef}
      dataProp={data}
    />
  );
};

PLPResultsHeader.displayName = 'PLPResultsHeader';

PLPResultsHeader.propTypes = {
  preamble: PropTypes.node,
};

PLPResultsHeader.defaultProps = {
  preamble: null,
};

PLPResultsHeader.themeProps = {
  hideShopAllLink: PropTypes.bool
};

PLPResultsHeader.defaultThemeProps = {
  hideShopAllLink: false
};

PLPResultsHeader.dataModel = {
  searchModel: params({
    keyword: string(),
    dataSources: string(),
    dataSource: string()
  }).shape({
    metadata: shape({
      contentType: string(),
      h1Tag: string()
    }),
    searchReport: shape({
      keyword: string(),
      correctedKeyword: string(),
      searchUrl: string()
    }),
    taxonomy: shape({
      breadCrumbs: arrayOf(shape({
        label: string(),
        url: string(),
        browseUrl: string(),
        dimensionName: string(),
        refinementKey: string()
      })),
      resultsHeader: arrayOf(shape({
        label: string(),
        url: string()
      }))
    }),
    aisles: arrayOf(shape({
      id: string(),
      name: string()
    }))
  })
};
